import { ConfirmComponent } from '$components/dialog/confirm.component';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfirmService {

  constructor(private readonly dialog: MatDialog) { }

  ConfirmDialog(title: string, text: string, cancel?:string, ok?:string): Observable<any> {
    return this.dialog.open(ConfirmComponent, {
      data: {
        title: title,
        text: text,
        cancel:cancel,
        ok:ok
      }
    }).afterClosed()
  }
}
